import React from "react";
import { Link } from "react-router-dom";
import "./Submission.scss";
import { useLanguage } from "../../i18n/LanguageContext";
import { footer, submission } from "../../i18n/content";

const Submission = () => {
  const { t } = useLanguage();

  return (
    <div className="submission_test_wrapper">
      <header className="lw-page-hero">
        <div className="lw-wrap">
          <div className="lw-eyebrow">
            <span className="lw-dot" />
            {t(submission.eyebrow)}
          </div>
          <h1>{t(submission.title)}</h1>
          <p>{t(submission.lede)}</p>
        </div>
      </header>

      <section className="lw-submit">
        <div className="lw-wrap">
          <div className="lw-steps">
            <div className="lw-step">
              <span className="lw-badge">01</span>
              <div>
                <h3>{t(submission.step1Title)}</h3>
                <p>{t(submission.step1Body)}</p>
              </div>
            </div>
            <div className="lw-step">
              <span className="lw-badge">02</span>
              <div>
                <h3>{t(submission.step2Title)}</h3>
                <p>{t(submission.step2Body)}</p>
              </div>
            </div>
            <div className="lw-step">
              <span className="lw-badge">03</span>
              <div>
                <h3>{t(submission.step3Title)}</h3>
                <p>{t(submission.step3Body)}</p>
              </div>
            </div>
          </div>

          <div className="lwt-rules">
            <div className="lwt-rule">
              <h3>{t(submission.ageTitle)}</h3>
              <p>{t(submission.ageBody)}</p>
            </div>
            <div className="lwt-rule">
              <h3>{t(submission.formTitle)}</h3>
              <p>
                {t(submission.formBodyPre)}{" "}
                <a
                  href="https://docs.google.com/document/d/1_Wbv635JRhd87VcjrFArw6ycTfFQPJH8/edit"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t(submission.formBodyLink)}
                </a>{" "}
                {t(submission.formBodyMid)}{" "}
                <a href="mailto:cinephoneadjaraff@gmail.com">
                  cinephoneadjaraff@gmail.com
                </a>
                .
              </p>
            </div>
          </div>

          <a
            className="lw-btn"
            href="mailto:cinephoneadjaraff@gmail.com"
          >
            {t(submission.emailCta)}
          </a>
        </div>
      </section>

      <footer className="lw-footer">
        <div className="lw-wrap lw-foot-bottom">
          <span>{t(footer.est)}</span>
          <Link to="/">{t(footer.backHome)}</Link>
        </div>
      </footer>
    </div>
  );
};

export default Submission;
